import { createSelector } from 'reselect';
 
const selectChapterSubscription = (state: any) => state.chapterSubscription;
 
export const selectChapterSubscriptionCurrentItem = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.current);
 
export const selectChapterSubscriptionListItems = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.list);
 
 
export const selectChapterSubscriptionItemById = (itemId: any) =>
    createSelector(selectChapterSubscriptionListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectChapterSubscriptionQueryItems = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.query);

export const selectChapterSubscriptionCreatedItem = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.create);
 
export const selectChapterSubscriptionUpdatedItem = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.update);
 
export const selectChapterSubscriptionReadItem = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.read);
 
export const selectChapterSubscriptionDeletedItem = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.delete);
 
export const selectChapterSubscriptionSearchedItems = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.search);
 
export const selectChapterSubscriptionItemsCount = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.count);
 
export const selectChapterSubscriptionItemsFilter = createSelector([selectChapterSubscription], (chapterSubscription) => chapterSubscription.filter);